import React from "react";
import "./GameIdeas.css";
import "../Gamecommon.css";
import gameimg2 from "../gameassets/gameimg2.jpg";
import gameimg3 from "../gameassets/gameimg3.jpg";
import gameimg4 from "../gameassets/gameimg4.jpg";
import gameimg5 from "../gameassets/gameimg5.jpg";
import gameimg6 from "../gameassets/gameimg6.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <button className="custom-arrow next" onClick={onClick}>
    <FaChevronRight />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="custom-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </button>
);

export default function GameIdeas() {
  const gameCards = [
    {
      section: "top",
      img: gameimg2,
      title: "Full-Cycle Game Development & Art Design",
      desc: "From concept to launch — including character art, 2D/3D assets, and animation — we provide complete game development services that cover every stage of production.",
    },
    {
      section: "top",
      img: gameimg3,
      title: "Mobile Game Development",
      desc: "Engaging iOS and Android games optimized for performance, retention, monetization, and viral growth.",
    },
    {
      section: "bottom",
      img: gameimg4,
      title: "PC & Console Game Development",
      desc: "AAA-quality games with high-fidelity graphics, realistic physics, responsive gameplay, and long-term player engagement.",
    },
    {
      section: "bottom",
      img: gameimg5,
      title: "AR/VR & Metaverse Games",
      desc: "Immersive AR, VR, and metaverse experiences that transport players into interactive, next-gen worlds.",
    },
    {
      section: "bottom",
      img: gameimg6,
      title: "Blockchain & NFT Game Development",
      desc: "Secure, scalable Web3 ecosystems with play-to-earn (P2E) mechanics, NFT integrations, and decentralized economies.",
    },
  ];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: false,
  adaptiveHeight: true,
  centerMode: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 992, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true, 
      },
    },
    {
      breakpoint: 576, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false, 
      },
    },
  ],
};


  return (
    <div id="gameideas" className="gamemainclass">
      {/* <span className="span-tag">Our Game Development Expertise</span> */}
      <h2 className="h2-tag">Trusted Game Development Company Worldwide</h2>
      <p className="p-tag">
       We offer services with legacy — we build game development solutions that align with your vision and delight players.
      </p>

      {/* Desktop Cards */}
      <div className="cards">
        <div className="top-cards">
          {gameCards
            .filter((card) => card.section === "top")
            .map((card, index) => (
              <div className="card" key={index}>
                <div className="image-container">
                  <img src={card.img} alt={card.title} />
                  <div className="overlay"></div>
                </div>
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
        </div>
        <div className="bottom-cards">
          {gameCards
            .filter((card) => card.section === "bottom")
            .map((card, index) => (
              <div className="card" key={index}>
                <div className="image-container">
                  <img src={card.img} alt={card.title} />
                  <div className="overlay"></div>
                </div>
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* Mobile Carousel */}
      <div className="mobile-cards">
        <Slider {...settings}>
          {gameCards.map((card, index) => (
            <div className="card-wrapper" key={index}>
              <div className="card">
                <div className="image-container">
                  <img src={card.img} alt={card.title} />
                  <div className="overlay"></div>
                </div>
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
